/* eslint-disable no-console */
import React, {Component} from 'react'
import { connect } from 'react-redux'
import Index from './components/Index/Index'

import {
  fetchAccount, fetchMarketGeo, fetchOverdueFeeFlags
} from 'broker/redux/account'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class IndexContainer extends Component {

    constructor(props) {
      super(props)
    }

    componentWillMount() {
      this.props.dispatch(fetchAccount())
      this.props.dispatch(fetchMarketGeo())
      this.props.dispatch(fetchOverdueFeeFlags())
    }

    render() {
      return <Index {...this.props} />
    }
}

export default connect((state) => ({ account: state.account, auth: state.auth }), mapDispatchToProps)(IndexContainer)
